import { createAction, createSlice } from "@reduxjs/toolkit";
import { Location } from "../../@types/location";
import { findLocations } from "./actions/findLocations";
interface LocationsState {
  locations: Location[];
  partOfFilter: Location[];
  partOfFilterVisible: boolean;
  searchText: string;
}

const initialState = {
  locations: [],
  partOfFilter: [],
  partOfFilterVisible: false,
  searchText: "",
} as LocationsState;

export const setSearchText = createAction<string>("SET_SEARCH_TEXT");
export const setPartOfFilter = createAction<any>("SET_PART_OF_FILTER");
export const setPartOfFilterVisible = createAction<boolean>("setPartOfFilterVisible");

const locationsSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setPartOfFilterVisible, (state, { payload }) => {
        state.partOfFilterVisible = payload;
      })
      .addCase(findLocations.fulfilled, (state, { payload }) => {
        state.locations = payload;
      })
      .addCase(setSearchText, (state, { payload }) => {
        state.searchText = payload;
      })
      .addCase(setPartOfFilter, (state, { payload }) => {
        state.partOfFilter = payload;
      });
  },
});

export default locationsSlice.reducer;
